<ng-container *transloco="let t;">
    <div ngbDropdown class="actionTD template-listing-action-btn d-flex justify-content-end">
                <button type="button" class="btn btn-sm hide-arrow"
                        ngbDropdownToggle data-toggle="dropdown"
                        (click)="$event.stopPropagation()">
                    <i data-feather="more-vertical"></i>
                </button>
                <div ngbDropdownMenu class="dropdown-menu-right" (click)="$event.stopPropagation()">
                    <a ngbDropdownItem (click)="deletePlayBook()">
                        <i data-feather="trash" [size]="16" class="me-50"></i>
                        <span>{{ t('Delete permanently - label (general) - Delete permanently') }}</span>
                    </a>
                </div>
    </div>
</ng-container>